import { useEffect, useState } from "react";

/**
 * Re-renders the caller on a fixed interval so time-derived values (e.g. the XP
 * bar's sub-tick fraction) advance live between backend polls. Returns the
 * current epoch-ms. Scope this to the smallest component that needs it so the
 * rest of the tree doesn't re-render every tick.
 */
export function useNow(intervalMs: number = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
